import { useS3Upload } from '../../../../../../../../utils'
import { useCreateAttachmentMutation } from './CreateAttachment.generated'
import { useCompleteAttachmentMutation } from './CompleteAttachment.generated'

export function useAttachmentUpload() {
  const upload = useS3Upload()

  const [create] = useCreateAttachmentMutation()
  const [complete] = useCompleteAttachmentMutation()

  return async function attachmentUpload(file: File) {
    {
      const createRes = await create({ variables: { fileName: file.name } })

      if (createRes.data.CreateAttachment) {
        await upload({ url: createRes.data.CreateAttachment.uploadUrl }, file)
        const uploadRes = await complete({
          variables: { id: createRes.data.CreateAttachment._id },
        })

        return uploadRes.data.CompleteAttachment
      }

      throw new Error('Error creating attachment')
    }
  }
}
